import React from 'react';
import { Route } from 'react-router-dom';

import { WithNotFound } from '../errors';
import { CampaignCreation } from './campaignsCreation';
import { CampaignsLists } from './campaignsLists';
import { CampaignEdit } from './campaignsEdit';
import { CampaignsCompleted } from './campaignsDetails';
import { DiscountsLists } from './discountsLists';
import { DiscountEdit } from './discountsEdit';

const MarketingRoutes = () => (
    <WithNotFound>
        <Route path="/:accountId/marketing/campaigns/new" exact component={CampaignCreation} />
        <Route path="/:accountId/marketing/campaigns/copy/:discountId" exact component={CampaignCreation} />
        <Route path="/:accountId/marketing/campaigns" exact component={CampaignsLists} />
        <Route path="/:accountId/marketing/campaigns/:campaignId/edit" exact component={CampaignEdit} />
        <Route path="/:accountId/marketing/campaigns/:campaignId/completed" exact component={CampaignsCompleted} />
        <Route path="/:accountId/marketing/discounts" exact component={DiscountsLists} />
        <Route path="/:accountId/marketing/discounts/:discountId" exact component={DiscountEdit} />
    </WithNotFound>
);

export default MarketingRoutes;
